export default __webpack_public_path__ + "static/media/place-marker.33bc716e.png";